import React from "react";
import "./style.scss";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";

import BlockPracticeAreas from "components/BlockPracticeAreas";

export default function BlockServicesPracticeAreas() {
  const { t } = useTranslation();

  const prepend = (
    <>
      <h2 className="block-practice-areas__title h2 mb-4 text-center">
        {t("Wherever your students aim, our coaches have lived it")}
      </h2>
      <div className="block-practice-areas__description subtitle-1 text-center text-neutral-darken-1 mb-10">
        {t(
          "Our approach is designed by people who’ve worked across the industry — so wherever your students aim, our coaches have been there."
        )}
      </div>
    </>
  );

  const append = (
    <div className="block-services-practice-areas__price-wrapper box-shadow d-flex mt-10">
      <div className="block-services-practice-areas__price">{t("Ready to take the next step?")}</div>
      <BaseButton className="block-services-practice-areas__btn" to={"/coaches"} large gradient>
        {t("Find a Coach")}
        <BaseIcon className="f-shrink-0 ml-1">chevron-right</BaseIcon>
      </BaseButton>
    </div>
  );

  return <BlockPracticeAreas prepend={prepend} append={append} />;
}
